const AppConfig = {
  ...process.env,
  ...((document && document.BEVSPOT_APPLICATION_CONFIG) || {}),
};

export default AppConfig
